const savingsGoalSuggestions = [
  "How to save $100,000 in 6 months",
  "How to buy cheap groceries",
  "Save for a dream vacation",
  "Build an emergency fund fast",
  "How to save for a new car",
  "Cut monthly subscriptions",
  "Save for a house down payment",
  "How to become debt-free",
  "Budget for a wedding",
  "Save money on utilities",
  "How to meal prep on a budget",
  "Reduce transportation costs",
  "Save for retirement early",
  "How to travel on a budget",
  "Pay off student loans faster",
  "Start investing with $100",
  "Save $500 a month on food",
  "How to live frugally and love it",
  "Build a $10,000 safety net",
  "How to negotiate lower rent",
  "Stop impulse buying for good",
  "How to save on health insurance",
  "Best free financial tools to use",
  "How to save money as a student",
  "Save money on kids' clothes",
  "How to save $50 a week easily",
  "Cheapest internet and phone plans",
  "How to reduce energy bills by 30%",
  "Ways to save on pet expenses",
  "How to save for a baby",
  "Saving money on laundry costs",
  "How to get free entertainment",
  "Best cashback apps to use daily",
  "How to coupon like a pro",
  "Save money on holiday shopping",
  "How to save on back-to-school",
  "Best budgeting methods ranked",
  "How to stop eating out so much",
  "Cheapest meal prep recipes",
  "Save money on gym memberships",
  "How to DIY home repairs cheaply",
  "Saving on car insurance premiums",
  "How to save on prescription meds",
  "Best discount grocery stores",
  "How to save for college tuition",
  "Reduce your water bill by half",
  "How to save money on clothing",
  "Thrift store shopping strategies",
  "How to save money on haircuts",
  "Best free budgeting apps",
  "How to save on streaming services",
  "Cancel subscriptions you forgot about",
  "How to save $1,000 in 30 days",
  "Best side hustles for extra cash",
  "How to sell stuff you don't need",
  "Save money on cleaning supplies",
  "DIY gifts to save on birthdays",
  "How to save on dental care",
  "Cheapest ways to commute to work",
  "How to carpool and save money",
  "Electric vs gas car cost savings",
  "How to save on home heating",
  "Best free online courses for finance",
  "How to negotiate your salary",
  "Save on childcare costs",
  "How to save on vacation flights",
  "Best travel rewards credit cards",
  "How to use loyalty programs wisely",
  "Save money on coffee every day",
  "Brew your own beer at home",
  "How to grow food in your garden",
  "Composting to save on fertilizer",
  "How to fix clothes instead of buying",
  "Save on makeup and beauty products",
  "How to save money at Costco",
  "Bulk buying tips that actually work",
  "Best apps for comparing prices",
  "How to negotiate medical bills",
  "Save money on wedding planning",
  "How to elope and save thousands",
  "Cheap date night ideas",
  "How to save on anniversary gifts",
  "Best free date activities",
  "How to save on home furniture",
  "Buy refurbished electronics safely",
  "How to save on smartphone plans",
  "Switch to prepaid and save $50/month",
  "How to reduce your tax burden",
  "Tax deductions you might be missing",
  "How to save on property taxes",
  "Refinance your mortgage and save",
  "How to save on closing costs",
  "Best high-yield savings accounts",
  "How CDs can grow your savings",
  "I-bonds for inflation protection",
  "How to start a Roth IRA",
  "401k matching: free money explained",
  "How to save on bank fees",
  "Switch to a credit union and save",
  "No-fee checking accounts ranked",
  "How to avoid ATM fees forever",
  "Best money market accounts",
  "How to save on wire transfer fees",
  "Automate savings with round-ups",
  "The 50/30/20 budget explained",
  "Zero-based budgeting for beginners",
  "Envelope budgeting system guide",
  "How to use sinking funds",
  "Save money on baby formula",
  "Cloth diapers vs disposable savings",
  "How to save on school lunches",
  "Pack lunch and save $2,000/year",
  "How to save on work clothes",
  "Capsule wardrobe to save money",
  "How to save on dry cleaning",
  "Wash clothes in cold water savings",
  "Air dry clothes to save energy",
  "How to save on holiday travel",
  "Off-season travel deals explained",
  "How to use airline miles wisely",
  "Hotel alternatives that save money",
  "House sitting for free accommodation",
  "How to save on rental cars",
  "Public transit savings calculator",
  "Biking to work to save money",
  "Walking more to cut gas costs",
  "How to save on parking fees",
  "Best free parking apps",
  "How to save on toll roads",
  "Carpooling apps that save money",
  "Electric scooter vs car savings",
  "How to maintain your car cheaply",
  "DIY oil change to save money",
  "Best cheap tire brands",
  "How to save on car washes",
  "Wash your car at home and save",
  "How to save on auto repairs",
  "Learn basic car maintenance free",
  "How to save on roadside assistance",
  "Best free roadside help programs",
  "How to reduce food waste at home",
  "Freeze leftovers and save money",
  "Batch cooking to save time and cash",
  "How to save at the farmers market",
  "Seasonal produce buying guide",
  "Grow herbs at home and save",
  "How to make homemade bread",
  "Save money making your own pasta",
  "How to can and preserve food",
  "Dehydrating food to reduce waste",
  "How to save on organic food",
  "Dirty dozen: when to buy organic",
  "How to save on gluten-free food",
  "Cheap protein sources ranked",
  "How to save on vitamins",
  "Generic vs brand medicine savings",
  "How to save on eye care costs",
  "Best vision insurance alternatives",
  "How to save on therapy costs",
  "Free mental health resources",
  "How to save on fitness classes",
  "YouTube workout channels for free",
  "Running as a free exercise",
  "How to save on sports equipment",
  "Buy used gear and save big",
  "How to save on camping trips",
  "Free campsite finding tips",
  "How to save on hiking gear",
  "Borrow gear instead of buying",
  "Library card: free entertainment",
  "Free museum days in your city",
  "How to save on concert tickets",
  "Volunteer at events for free entry",
  "How to save on movie tickets",
  "Matinee pricing explained",
  "How to save on books and reading",
  "Free e-book sources online",
  "How to save on magazine subs",
  "Free news sources worth reading",
  "How to save on video games",
  "Free-to-play games worth trying",
  "Game pass vs buying games",
  "How to save on hobby supplies",
  "Cheap hobbies that are fulfilling",
  "How to save on art supplies",
  "Free online art classes",
  "How to save on music lessons",
  "Free instrument learning apps",
  "How to save on photography",
  "Smartphone photography tips",
  "How to save on printing photos",
  "Digital photo storage solutions",
  "How to save on gift wrapping",
  "Newspaper wrapping hack",
  "How to save on party supplies",
  "Dollar store party planning",
  "How to save on home decor",
  "DIY wall art ideas",
  "How to save on paint costs",
  "Repaint a room for under $50",
  "How to save on plumbing repairs",
  "Fix a leaky faucet yourself",
  "How to save on electrical work",
  "LED bulb savings calculator",
  "Smart thermostat savings guide",
  "Programmable thermostat tips",
  "How to insulate your home cheaply",
  "Weather stripping to save energy",
  "How to save on AC costs",
  "Fans vs AC: cost comparison",
  "How to save on heating oil",
  "Space heater efficiency tips",
  "Solar panel savings breakdown",
  "How to save on lawn care",
  "Mow your own lawn and save",
  "How to save on pest control",
  "Natural pest remedies at home",
  "How to save on pool maintenance",
  "DIY pool cleaning guide",
  "How to save on snow removal",
  "Shovel vs snowblower costs",
  "How to save on home security",
  "DIY security camera setup",
  "How to save on renters insurance",
  "Bundle insurance and save 20%",
  "How to save on life insurance",
  "Term vs whole life explained",
  "How to save on umbrella insurance",
  "How to save on flood insurance",
  "Emergency fund vs insurance balance",
  "How to save on moving costs",
  "DIY moving tips and tricks",
  "How to save on storage units",
  "Declutter and avoid storage fees",
  "How to save on furniture delivery",
  "Pick up furniture yourself and save",
  "How to save on appliance repairs",
  "Fix appliances with YouTube videos",
  "How to save on kitchen gadgets",
  "Essential vs unnecessary gadgets",
  "How to save on cookware",
  "Cast iron: buy once, save forever",
  "How to save on baking supplies",
  "Homemade baking mixes recipe",
  "How to save on spices and herbs",
  "Buy spices in bulk and save",
  "How to save on condiments",
  "Make your own sauces at home",
  "How to save on beverages",
  "Drink more water and save money",
  "How to save on alcohol costs",
  "Happy hour strategies",
  "How to save on wine purchases",
  "Wine clubs worth joining",
  "How to save on holiday meals",
  "Potluck hosting to share costs",
  "How to save on Thanksgiving dinner",
  "Turkey deals and timing tips",
  "How to save on Christmas gifts",
  "Secret Santa to reduce gift costs",
  "How to save on Valentine's Day",
  "Homemade Valentine's gift ideas",
  "How to save on Mother's Day",
  "DIY Mother's Day gifts",
  "How to save on Father's Day",
  "Experience gifts vs material gifts",
  "How to save on Easter baskets",
  "Homemade Easter treats",
  "How to save on Halloween costumes",
  "DIY costume ideas under $10",
  "How to save on trick-or-treat candy",
  "Buy candy after Halloween sales",
  "How to save on New Year's Eve",
  "Host a house party instead",
  "How to save on birthday parties",
  "Park birthday party ideas",
  "How to save on graduation gifts",
  "Meaningful gifts on a budget",
  "How to save on teacher gifts",
  "Group gift card collections",
  "How to save on coworker gifts",
  "Set a gift budget and stick to it",
  "How to save on shipping costs",
  "Free shipping tricks and codes",
  "How to save on Amazon purchases",
  "Amazon price tracking tools",
  "How to save on eBay",
  "eBay bidding strategies",
  "How to save at thrift stores",
  "Best thrift store shopping days",
  "How to save at garage sales",
  "Garage sale negotiation tips",
  "How to save on Facebook Marketplace",
  "Spot deals on Marketplace",
  "How to save on Craigslist",
  "Craigslist safety and savings tips",
  "How to save with browser extensions",
  "Best coupon browser extensions",
  "How to save with rebate apps",
  "Ibotta and Fetch rewards guide",
  "How to save on grocery delivery",
  "Pickup vs delivery cost comparison",
  "How to save on meal kit services",
  "Recreate meal kits at home",
  "How to save on takeout food",
  "Cook restaurant meals at home",
  "How to save on pizza delivery",
  "Homemade pizza recipes",
  "How to save on Uber Eats fees",
  "Pickup orders to avoid delivery fees",
  "How to save on DoorDash",
  "DashPass: worth it or not",
  "How to save at restaurants",
  "Restaurant week deals explained",
  "How to save with happy hour menus",
  "Early bird dinner specials",
  "How to save on tipping costs",
  "Understanding tipping etiquette",
  "How to save on fast food",
  "Fast food app deals and coupons",
  "How to save on Starbucks",
  "Make Starbucks drinks at home",
  "How to save on smoothies",
  "Homemade smoothie recipes",
  "How to save on juice and soda",
  "Switch to water infusions",
  "How to save on snacks",
  "Homemade snack ideas for kids",
  "How to save on office supplies",
  "Buy office supplies in bulk",
  "How to save on printer ink",
  "Refill cartridges vs buying new",
  "How to save on paper products",
  "Go paperless and save money",
  "How to save on postage and mail",
  "Email instead of snail mail",
  "How to save on phone cases",
  "Best cheap phone case brands",
  "How to save on laptop accessories",
  "Essential vs luxury tech accessories",
  "How to save on software",
  "Free alternatives to paid software",
  "How to save on cloud storage",
  "Free cloud storage options compared",
  "How to save on VPN services",
  "Best affordable VPN deals",
  "How to save on antivirus software",
  "Free antivirus that actually works",
  "How to save on domain names",
  "Domain registrar price comparison",
  "How to save on web hosting",
  "Best budget hosting providers",
  "How to save on online courses",
  "Free course platforms ranked",
  "How to save on certifications",
  "Employer-sponsored certifications",
  "How to save on professional development",
  "Free LinkedIn Learning courses",
  "How to save on conference attendance",
  "Virtual conference alternatives",
  "How to save on business cards",
  "Digital business card options",
  "How to save on networking events",
  "Free meetup groups to join",
  "How to save on commuting snacks",
  "Pack snacks from home",
  "How to save on work lunches",
  "Meal prep Sunday guide",
  "How to save on work shoes",
  "Comfortable affordable work shoes",
  "How to save on professional attire",
  "Build a work wardrobe on a budget",
  "How to save on dry cleaning bills",
  "At-home stain removal tips",
  "How to save on ironing",
  "Wrinkle-free fabric choices",
  "How to save on personal care",
  "DIY personal care products",
  "How to save on shampoo",
  "Shampoo bars vs bottles savings",
  "How to save on skincare",
  "Simple skincare routine on a budget",
  "How to save on sunscreen",
  "Best drugstore sunscreens",
  "How to save on razors",
  "Safety razor long-term savings",
  "How to save on toothpaste",
  "Baking soda dental hacks",
  "How to save on deodorant",
  "Natural deodorant recipes",
  "How to save on perfume and cologne",
  "Fragrance dupes that smell great",
  "How to save on contact lenses",
  "Online lens retailers compared",
  "How to save on glasses frames",
  "Affordable online eyewear stores",
  "How to save on hearing aids",
  "Over-the-counter hearing aid options",
  "How to save on elder care",
  "Community resources for seniors",
  "How to save on funeral costs",
  "Pre-planning to reduce expenses",
  "How to save on legal fees",
  "Free legal aid resources",
  "How to save on tax preparation",
  "Free tax filing options",
  "How to save on accounting fees",
  "DIY bookkeeping tools",
  "How to save on financial advisors",
  "Robo-advisors vs human advisors",
  "How to save on investment fees",
  "Low-cost index fund investing",
  "How to save on trading commissions",
  "Commission-free brokerages ranked",
  "How to save on crypto fees",
  "Best low-fee crypto exchanges",
  "Dollar cost averaging explained",
  "How compound interest saves you money",
  "The latte factor: small savings add up",
  "No-spend challenge for a month",
  "52-week savings challenge guide",
  "How to do a spending fast",
  "Track every penny for 30 days",
  "Cash-only spending experiment",
  "How to negotiate any bill lower",
  "Call and ask for a discount",
  "Loyalty discounts you never knew about",
  "Student discounts you can still use",
  "Military and veteran discounts guide",
  "Senior citizen discount programs",
  "AAA membership savings breakdown",
  "AARP benefits worth knowing",
  "How to save with employer perks",
  "FSA and HSA savings strategies",
  "Commuter benefits explained",
  "How to maximize credit card rewards",
  "Points vs cashback: which is better",
  "Balance transfer to save on interest",
  "How to pay off credit card debt fast",
  "Snowball vs avalanche debt method",
  "How to save on personal loan rates",
  "Peer-to-peer lending explained",
  "How to save on payday loan alternatives",
  "Credit union emergency loans",
  "How to improve your credit score free",
  "Free credit monitoring services",
  "How to dispute credit report errors",
  "Negotiate lower interest rates",
];

export default savingsGoalSuggestions;
